























import { Vue, Component, Watch } from 'vue-property-decorator';
import Container from '../../components/Container.vue';

const tabs = ['Groups', 'Events'];

@Component({
  components: {
    Container,
    EventsTab: () => import('./Events.tab.vue'),
    GroupsTab: () => import('./Groups.tab.vue')
  }
})
export default class JBICManagement extends Vue {
  public activeTab = 0;

  public mounted() {
    const index = tabs.indexOf(this.$route.query.tab as string);

    if (index >= 0) {
      this.activeTab = index;
    } else {
      this.$router.push({
        query: { ...this.$route.query, tab: tabs[this.activeTab] }
      });
    }
  }

  @Watch('activeTab')
  public onTabChange(value: number) {
    if (this.$route.query.tab === tabs[value]) {
      return;
    }

    this.$router.push({
      query: { ...this.$route.query, tab: tabs[value] }
    });
  }
}
